// MOCK DATA: Search History is not connected to the API yet.
// Replace getSearchHistory with a call to the backend once the history endpoint exists.

const MINUTE = 60 * 1000;

const MOCK_SEARCHES = [
    { question: 'Key insights for Dr. Maheswaran', minutesAgo: 34 },
    { question: 'Who are new writers in my region?', minutesAgo: 45 },
    { question: 'Show me the top HCPs for Blue Cross Blue Shield of California', minutesAgo: 48 },
    { question: 'Key insights for Dr. Smith', minutesAgo: 60 * 24 + 54 },
    { question: "What's the coverage status of a payer?", minutesAgo: 60 * 24 * 3 + 20 },
];

/**
 * Returns the user's searches from the last 7 days, newest first.
 * @returns {Promise<Array<{id: string, question: string, searchedAt: Date}>>}
 */
export async function getSearchHistory() {
    const now = Date.now();
    return MOCK_SEARCHES.map((s, i) => ({
        id: `mock-${i}`,
        question: s.question,
        searchedAt: new Date(now - s.minutesAgo * MINUTE),
    }));
}
